import type { FaireThemeEntity } from "../../entity_types/theme";

export const puka_pearl_beach_jewelry: FaireThemeEntity = {
  token: "puka-pearl-beach-jewelry",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Puka & Pearl Beach Jewelry",
  description: "Bestselling coastal jewelry for beach-town visitors",
  bgColor: "#F5E6C8",
  tileBgColor: "#3b5590",
  productTokens: [
    "p_z2e7wjxu6t",
    "p_qsmqm9z8e9",
    "p_u8bggjh4b8",
    "p_3kjb442ycs",
    "p_zpp8zwtkkx",
    "p_arz9emkv7x",
    "p_5wpbk2wf94",
    "p_pmqnsgzxk8",
    "p_6cn92btzdn",
    "p_nqyd962k4j",
    "p_3s0nl3yzqm",
    "p_bua5tpa8sy",
    "p_e7atjqef73",
    "p_7773hw9ftf",
    "p_w7sxatuqfk",
    "p_d5rhvupy",
    "p_grrr372522",
    "p_e87egkwqjz",
    "p_91ld4gsp",
    "p_4n6uvfzpqq",
    "p_haezay2279",
    "p_km8azg873p",
    "p_r86f5gkb5f",
    "p_v4qhkd8x8h",
    "p_6za2wg6kq4",
    "p_2h2s88xf69",
    "p_c3zfjr6626",
    "p_jn8ekbynsm",
    "p_utf9dhnz25",
    "p_mq9jk74vhh",
    "p_d4ar0wikxd",
    "p_5e2kbarykm",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
